export const booleanFilter = <T>(
  value: T | false | null | undefined | '' | 0,
): value is T => Boolean(value);

export const sortByIndexOptional = (
  a: { index?: number },
  b: { index?: number },
) => {
  // indize can be zero
  if (typeof a.index !== 'number') return -1;
  if (typeof b.index !== 'number') return 1;
  return a.index - b.index;
};
